var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ul",
    {
      staticClass: "widget-list widget-options",
    },
    [
      _c("li", [
        _c(
          "a",
          {
            staticClass: "options-checkbox",
            class: _vm.showNewContents
              ? "options-checked"
              : "options-unchecked",
            attrs: {
              href: "#",
            },
            on: {
              click: function click($event) {
                $event.preventDefault()
                return _vm.toggleNewContents.apply(null, arguments)
              },
            },
          },
          [_c("translate", [_vm._v("Nur neue Inhalte anzeigen")])],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }